import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../assets/style-helpers.scss';

export const templateSubmitToSandboxPanel = document.createElement('template');

templateSubmitToSandboxPanel.innerHTML = `
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>
    <div class="content-wrapper">
      <div class="form-wrapper">
        <gz-form-field id="target-form-field" class='label-mw-250'>
          <gz-input gz-form-input inputWidth='240'></gz-input>
        </gz-form-field>
        <gz-form-field id="task-name-form-field" class='label-mw-250' required>
          <gz-input gz-form-input inputWidth='240'></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
        <gz-submit-to-sandbox-samples-form></gz-submit-to-sandbox-samples-form>
        <gz-submit-to-sandbox-settings-form></gz-submit-to-sandbox-settings-form>
      </div>
      <div class='bottom-buttons'>
        <gz-button id='save-button' disabled></gz-button>
        <div class='flex-auto'></div>
        <gz-button id='cancel-button' type='outline' color='secondary'></gz-button>
      </div>
    </div>
  </div>
`;
